// import actionTypes from '../actions/types';
import actionFactoryTypes from '../actions/actionsFactory/types';

export const INITIAL_STATE = {
  dribbleBtc: {},
  dribbleLog: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionFactoryTypes.FETCH_DRIBBLET_BTC:
      return { ...state, dribbleBtc: action.data };
    case actionFactoryTypes.FETCH_DRIBBLET_LOG:
      return { ...state, dribbleLog: action.data };
    default:
      return state;
  }
};
